import React, { useState } from 'react';
import axios from 'axios';
import { toast } from '../hooks/use-toast';
import { Send, CheckCircle2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsletterSignup = ({ source = 'blog' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email, source });
      setSubscribed(true);
      toast({
        title: res.data.already_subscribed ? "Already subscribed 🎉" : "You're in! 🎉",
        description: res.data.message,
      });
      setEmail('');
    } catch (error) {
      const msg = error?.response?.data?.detail || 'Something went wrong. Please try again.';
      toast({
        title: 'Subscription failed',
        description: msg,
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="bg-zinc-950 border border-tertiary rounded-xl p-8 lg:p-12 text-center"
      data-testid="newsletter-signup"
    >
      <div className="max-w-2xl mx-auto">
        <span className="text-xs text-tertiary font-sans uppercase tracking-wider">Newsletter</span>
        <h3 className="font-serif text-2xl lg:text-3xl text-gold mt-3 mb-3">
          Marketing insights, straight to your inbox
        </h3>
        <p className="text-sm text-secondary font-sans mb-8 leading-relaxed">
          Join the list and get actionable digital marketing strategies, case studies, and the
          latest AI growth tactics — no spam, unsubscribe anytime.
        </p>

        {subscribed ? (
          <div
            className="flex items-center justify-center gap-2 text-gold font-sans"
            data-testid="newsletter-success"
          >
            <CheckCircle2 className="w-5 h-5" />
            <span>Thanks for subscribing! Check your inbox soon.</span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
            data-testid="newsletter-form"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="flex-1 bg-black border border-tertiary rounded-lg px-4 py-3 text-white placeholder:text-tertiary font-sans text-sm focus:outline-none focus:border-gold transition-colors"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="bg-gold text-black font-sans font-medium text-sm px-6 py-3 rounded-lg hover:opacity-80 transition-opacity disabled:opacity-50 flex items-center justify-center gap-2"
              data-testid="newsletter-submit-button"
            >
              {loading ? 'Subscribing...' : 'Subscribe'}
              {!loading && <Send className="w-4 h-4" />}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default NewsletterSignup;
